import fetch from "isomorphic-fetch";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAuthenticatedHeaders } from "./apiHelpers";

const endpoint = spellbook("/auth/google/verify").POST();

export async function checkGoogleAuthentication(): Promise<null> {
    const call = createCall(endpoint, (request) => fetch(withAuthenticatedHeaders(request)));

    try {
        await call(undefined);
    } catch {
        // Spellbook handles the toast and auth redirect; keep this direct caller quiet.
    }

    return null;
}
